import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { SupplementaryInfoForm, UserStorageTabs } from '../../../components';
import { Preloader } from '../../../components/ui';
import { SHADOW_PROJECT_TYPE } from '../../../constants';
import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';

const UserSupplementaryInfo = ({ match, history }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, currentProject } = useCurrentProject(projectId);
  const { navigationPath } = usePaths();

  useEffect(() => {
    if (currentProject?.type === SHADOW_PROJECT_TYPE) {
      history.push({ pathname: navigationPath(projectId) });
    }
  }, [currentProject]);

  return (
    <UserStorageTabs>
      {!currentProjectFetching ? <SupplementaryInfoForm /> : <Preloader />}
    </UserStorageTabs>
  );
};

export default withRouter(UserSupplementaryInfo);
